import { FaDollarSign, FaStoreAlt, FaCog } from 'react-icons/fa'

const NavbarData = [
  {
    label: 'Planos e colaboradores',
    id: 'dashboard',
    path: '/company',
    icon: <FaDollarSign/>
  },
  {
    label: 'Salões',
    id: 'businesses',
    path: '/company/businesses',
    icon: <FaStoreAlt/>
  },
  {
    label: 'Configurações',
    id: 'config',
    path: '/company/config',
    icon: <FaCog/>
  },
]

export default NavbarData
